import { RoleInterface } from "../RoleInterface";
import { Role } from "../Role";
import Translator from "../../../../../Translation/Translator";

class Admin extends Role implements RoleInterface  {

  public static contactRoleId: number = 6;

  public getName(): string {
    return Translator.trans("role-admin");
  }

}

export { Admin }
